import { createFileRoute, redirect } from "@tanstack/react-router";

// 旧 /profile（マイページ）は /my-page へリダイレクト。
// /profile/$userId（他人プロフィール）は変更なし。
export const Route = createFileRoute("/_authenticated/profile/")({
  beforeLoad: () => {
    throw redirect({ to: "/my-page" });
  },
});
